enum ErrorMessage {
  HC003 = 'defaultError',
  HC009 = 'no_vacancies',
  HC012 = 'already_recruited',
  HL010 = 'no_vacancies',
  HL045 = 'no_vacancies',
}

export default ErrorMessage
